import styled from 'styled-components';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import Tabs from '@decisiv/ui-components/lib/components/Tabs';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';
import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

import PALETTES from '../../theme/palettes';

export const ProfileHeader = styled(Flex)`
  width: 100%;
  background: ${toColorString(color.base.snowWhite)};
  padding: ${rem(spacing.base * 2)} ${rem(spacing.base * 2.5)};
  align-items: center;
  gap: ${rem(spacing.base * 1.5)};
`;

export const ProfileHeaderInfo = styled(Flex)`
  flex-direction: column;
  gap: ${rem(spacing.base * 0.25)};
  flex: 1;
`;

export const ProfileContent = styled(Flex)`
  flex-direction: column;
  gap: ${rem(spacing.base * 2)};
  padding: ${rem(spacing.base * 2)};
  max-width: ${rem(700)};
  width: 100%;
`;

export const ProfileSection = styled(Flex)`
  flex-direction: column;
  background: ${toColorString(color.base.snowWhite)};
  border: 1px solid ${toColorString(color.opacity.charcoal15)};
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
`;

export const SectionHeader = styled(Flex)`
  align-items: center;
  padding: ${rem(spacing.base)} ${rem(spacing.base * 2)};
  border-bottom: 1px solid ${toColorString(color.opacity.charcoal15)};
  background: var(--if-surface-2);
`;

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${toColorString(color.base.charcoal)};
  margin: 0;
`;

export const InfoRow = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding: ${rem(spacing.base)} ${rem(spacing.base * 2)};
  border-bottom: 1px solid ${toColorString(color.opacity.charcoal15)};

  &:last-child {
    border-bottom: none;
  }
`;

export const ProfileTabs = styled(Tabs)`
  padding: 0;
  width: 100%;

  & > div:nth-child(1) {
    padding: 0 ${rem(spacing.base * 2)};
    background: var(--if-surface-1);
  }
`;

export const FeatureRow = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  gap: ${rem(spacing.base * 2)};
  padding: ${rem(spacing.base * 1.5)} ${rem(spacing.base * 2)};
  border-top: 1px solid var(--if-border);
`;

export const FeatureText = styled(Flex)`
  flex-direction: column;
  gap: ${rem(spacing.base * 0.25)};
`;

export const PaletteList = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: ${rem(spacing.base * 1.5)};
  padding: ${rem(spacing.base)} ${rem(spacing.base * 2)}
    ${rem(spacing.base * 1.5)};

  /* Swatches occupy the first column, one per palette row of the RadioGroup */
  & > div:last-child {
    grid-column: 2;
    grid-row: 1 / span ${PALETTES.length};
  }
`;

export const PaletteRow = styled.div`
  grid-column: 1;
  display: flex;
  align-items: center;
  height: ${rem(spacing.base * 3)};
`;

export const PaletteSwatch = styled.span`
  display: inline-grid;
  grid-auto-flow: column;
  width: ${rem(spacing.base * 6)};
  height: ${rem(spacing.base * 1.6)};
  border-radius: ${rem(spacing.base * 0.4)};
  overflow: hidden;
  border: 1px solid var(--if-border);

  & > i {
    display: block;
  }
`;

export const SectionBody = styled.div`
  padding: ${rem(spacing.base)} ${rem(spacing.base * 2)}
    ${rem(spacing.base * 1.5)};
`;
